<template>
    <div class="modal-content-subscribe-newslstter__container">
        <div class="modal-content-subscribe-newslstter__left">
            <div class="find-space-logo">
                <img src="/images/icons/logo-full-black.svg" alt="A Perfect Space"/>
            </div>
            <h3>Subscribe to get our latest insights and inspiration</h3>
        </div>
        <div class="modal-content-subscribe-newslstter__right">
            <form
                method="post"
                action="/api/subscribe/newsletter"
                @submit.prevent="submit"
            >
                <div class="flex-group">
                    <div class="flex-col flex-4">
                        <div class="form-group">
                            <label for="newsletter-first-name"
                                >First name <span class="required">*</span></label
                            >
                            <input
                                id="newsletter-first-name"
                                type="text"
                                name="first_name"
                                v-model="subscriber.first_name"
                                required
                            />
                        </div>
                    </div>
                    <div class="flex-col flex-4">
                        <div class="form-group">
                            <label for="newsletter-last-name"
                                >Last name <span class="required">*</span></label
                            >
                            <input
                                id="newsletter-last-name"
                                type="text"
                                name="last_name"
                                v-model="subscriber.last_name"
                                required
                            />
                        </div>
                    </div>
                    <div class="flex-col flex-4">
                        <div class="form-group">
                            <label for="newsletter-email"
                                >Email address <span class="required">*</span></label
                            >
                            <input
                                id="newsletter-email"
                                type="email"
                                name="email"
                                v-model="subscriber.email"
                                required
                            />
                        </div>
                    </div>
                    <div class="flex-col flex-6">
                        <div class="form-group">
                            <label for="i-am-interested-in"
                                >I am interested in
                                <span class="required">*</span></label
                            >
                            <select
                                id="i-am-interested-in"
                                name="interested_in"
                                v-model="subscriber.interested_in"
                                required
                            >
                                <option>Listing a space</option>
                                <option>Hiring a space</option>
                                <option>I’m just here for the great content</option>
                            </select>
                            <i class="icon selectCaretGeneric">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none"><path d="M10.5 5H12.725C15.4833 5 16.6167 6.95833 15.2333 9.35L14.1167 11.275L13 13.2C11.6167 15.5917 9.35833 15.5917 7.975 13.2L6.85833 11.275L5.74167 9.35C4.38333 6.95833 5.50833 5 8.275 5H10.5Z" stroke="#F4F4F5" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                            </i>
                        </div>
                    </div>
                    <div class="flex-col flex-4 newsletter-submit-wrap">
                        <div class="newsletter-privacy-policy">
                            By clicking 'Subscribe', you agree to our <a href="/privacy-policy" target="_blank">Privacy Policy</a> and <a href="/terms-and-conditions" target="_blank">Terms & Conditions</a>.
                        </div>
                        <div class="form-group submit">
                            <loader-button
                                type="submit"
                                :loading="loading"
                                label="Subscribe"
                                class="button primary block subscribe-btn-gtm"
                            ></loader-button>
                        </div>
                    </div>
                </div>
            </form> 
        </div>
    </div>
</template>

<script>
import BaseModal from "../Base";

// TODO loader

export default {
  extends: BaseModal,
  created: function () {
      this.subscriber.pageUri = window.location.href;
      this.subscriber.pageName = document.title;
  },
  methods: {
      submit(e) {
          this.loading = true;

          axios
              .post(e.target.action, this.subscriber)
              .then((response) => {
                  window.dataLayer.push({event: 'subscribe-submit'});

                  this.$toasted.show(
                      "Thanks for your interest! We've successfully added you to our mailing list.",
                      {
                          type: "success",
                      }
                  );
              })
              .catch((error) => {})
              .then(() => {
                  this.loading = false;
              });
      },
  },
  data() {
        return {
            subscriber: {
                first_name: "",
                last_name: "",
                email: "",
                interested_in: "",
                pageUri: "",
                pageName: "",
            },

            loading: false,
        };
    },
};
</script>

